import { GooglePayService as GooglePayCoreService } from '@wix/cashier-core/dist/src/services/GooglePay';
import { type GetBaseOptionsResponse } from '@wix/cashier-core/dist/src/services/GooglePay/types';
import { extractHostname } from '../url/extractHostname';
import { type AuthParams } from '../../types/AuthParams';
import { getAccountId } from './getAccountId';

interface getGooglePayBaseOptionsParams {
  baseURL?: string;
  auth: AuthParams;
  appDefId: string;
  appInstanceId: string;
  domain: string;
}

export const getGooglePayBaseOptions = async (
  params: getGooglePayBaseOptionsParams,
): Promise<GetBaseOptionsResponse> => {
  const { baseURL, appDefId, appInstanceId, auth, domain } = params;

  const googlePayMethodsService = new GooglePayCoreService({ baseURL, ...auth });
  const options: GetBaseOptionsResponse = await googlePayMethodsService.getBaseOptions({
    domain: extractHostname(domain),
    accountId: getAccountId(appDefId, appInstanceId),
  });
  return options;
};
